import { useContext } from 'react';

import drawerMenuContext from './drawer-menu-context';

export default function useDrawerMenuContext() {
    return useContext(drawerMenuContext);
}
